import React from "react";
import { GatsbyImage as PluginGatsbyImage } from "gatsby-plugin-image";

// gatsby-plugin-image's GatsbyImage, with the image's width and height written
// on its <img> in the HTML the server sends.
//
// The plugin adds those two attributes only after the page has loaded in the
// browser, so the HTML that crawlers read had none: the round-2 SEO crawl
// counted about 120 images per page type as missing their size. The numbers
// here are the ones the plugin itself sets after loading. Nothing moves on
// screen: the plugin's own CSS sizes the <img> to its wrapper, which already
// holds the image's space while it loads.
//
// Import GatsbyImage from here; getImage still comes from gatsby-plugin-image.
export const GatsbyImage = ({ image, ...props }) => {
  const size =
    image && image.layout !== "fullWidth" && image.width > 0 && image.height > 0
      ? { width: Math.round(image.width), height: Math.round(image.height) }
      : {};
  return <PluginGatsbyImage image={image} {...size} {...props} />;
};
